import React from "react";

import { FaFacebookSquare, FaLinkedin, FaGithub } from "react-icons/fa";
import Particle from "../../components/Particle";
import avatar from "../../img/avatar.jpg";
const Home = () => {
  return (
    <>
      <Particle />

      <div className="container">
        <div className="intro">
          <img alt="avatar" className="avatar" src={avatar} />
          <h1>Nguyễn Tuấn Quang</h1>
          <div className="vertical-flip">
            I'm a <span>Front-end developer</span>
            <span>Blockchain developer</span>
          </div>

          <ul className="social-icons">
            <li>
              <a href="https://www.facebook.com/tuanquang.nguyen.16/" target="blank">
                <FaFacebookSquare />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/quang-nguyen-a201b3191/" target="blank">
                <FaLinkedin />
              </a>
            </li>
            <li>
              <a href="https://github.com/ntquang22298" target="blank">
                <FaGithub />
              </a>
            </li>
          </ul>
          <div className="mt-4">
            <a className="btn" href="https://i.topcv.vn/nguyentuanquang?ref=2824737" target="blank">
              My CV
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
